<template>
  <section class='info' id="info">
    <b-container style="margin-top: 0; margin-bottom: 0">
      <b-row>
        <b-col cols="12" md="12" lg="12" align="center">
          <h1>
            {{ $t('info.title') }}
          </h1>
          <h2>
            <i>{{ $t('info.subtitle') }}</i>
          </h2>
          </b-col>
        </b-row>
        <hr>
      </b-container>
    <b-container>
      <b-row>
      <b-col cols="12" md="8" lg="6">
          <img class="img img__shadowed" style="margin-top: 6rem" src="@/assets/bitcoin.jpg" alt />
      </b-col>
      <b-col cols="12" md="12" lg="6">
          <h1>
           <br><br>
          </h1>
          <h3>
            {{ $t('info.exchangeIntro') }} <img src="@/assets/btc@2x.png" alt /> BTC (Bitcoin), <img src="@/assets/eth@2x.png" alt /> ETH (Ethereum) and <img src="@/assets/usdt@2x.png" alt /> USDT (Tether).<br>
          </h3>
          <p class="d-block d-lg-block">{{ $t('info.paragraph1') }}</p>
      </b-col>
      <b-col cols="12" md="12" lg="12">
          <p class="d-block d-lg-block" style="padding-top: 20px">{{ $t('info.paragraph2') }}</p>
          </b-col>
        </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang='sass'>
.info
  .btn__primary
    width: 40%
</style>